import React from 'react'
import { NavLink } from "react-router-dom";
import '../App.css';
const Navlinks = ({ toggle }) => {
    return (
        <ul className="nav navbar-nav myDropdown" id="top" >

            <li className="dropdown"> <NavLink onClick={toggle} className="dropbtn" to="/">Home</NavLink> </li>

            <li className="dropdown">
                <a className="dropbtn">About &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">
                    <NavLink onClick={toggle} to="/aboutsansta">About Institute </NavLink>
                    <NavLink onClick={toggle} to="/founderofmnsp">Founder of MSPM</NavLink>
                    <NavLink onClick={toggle} to="/governingbodyofmspm">Governing Body MSPM</NavLink>
                    <NavLink onClick={toggle} to="/founderofdgtc">Founder of College</NavLink>
                    <NavLink onClick={toggle} to="/presidantofmspm">President Of MSPM</NavLink>
                    <NavLink onClick={toggle} to="/secretoryofmspm">Secretary Of MSPM</NavLink>
                    <NavLink onClick={toggle} to="/college-cdc">College CDC</NavLink>
                    <NavLink onClick={toggle} to="/clgVisionMission">Vision,Mission & Objectives</NavLink>
                    <NavLink onClick={toggle} to="/facilities"> College Facilities </NavLink>
                    <a href="../documents/clg committiee/Clg-Committees.pdf"> College Commitiee </a>
                </div>
            </li>

            <li className="dropdown">
                <a className="dropbtn">Courses &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">

                    <a>BA &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <NavLink onClick={toggle} to="/history">History</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/marathi">Marathi</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/hindi">Hindi</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/Geography">Geography</NavLink>
                            </li>
                        </ul>
                    </a>
                    <NavLink onClick={toggle} to="/chemistry">B.Sc. (Chemistry)</NavLink>
                    <NavLink onClick={toggle} to="/bscit#top">B.Sc. IT</NavLink>
                    <NavLink onClick={toggle} to="/BMS">B.M.S.</NavLink> 
                    <a>Commerce &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <NavLink onClick={toggle} to="/Bcom">B.Com.</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/baf">BAF</NavLink>
                            </li> 
                        </ul>
                    </a>

                    <a>PG &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <NavLink onClick={toggle} to="/history">M.A. History</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/marathi">M.A. Marathi</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/hindi">M.A. Hindi</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/chemistry">M.Sc(Organic Chemistry)</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={toggle} to="/bscit#top">M.Sc I.T</NavLink>
                            </li> 
                            <li>
                                <NavLink onClick={toggle} to="/Bcom">M.Com</NavLink>
                            </li> 
                        </ul>
                    </a> 
                    <a>ADD ON &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                        <li>
                                <a onClick={toggle} href="../documents/naac/support document/Add-comm.pdf"  >Add On Commitee </a> 
                    </li>
                    <li>
                                <a onClick={toggle} href="../documents/naac/support document/Add on Appoinments.pdf"  >Add On Courses </a> 
                    </li>
                        </ul>
                    </a>

                    
                </div>
            </li>

            <li className="dropdown">
                <a className="dropbtn">Academics &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">
                    <NavLink onClick={toggle} to="/adacmiccal">Academic Calender</NavLink>
                    <NavLink onClick={toggle} to="/termwise-schedule">Termwise Schedule</NavLink>
                    <NavLink onClick={toggle} to="/daywise-schedule">Daywise Schedule</NavLink>
                    <NavLink onClick={toggle} to="/office-schedule"> OfficeWork Schedule</NavLink>
                    <NavLink onClick={toggle} to="/library-schedule">Library Schedule </NavLink>
                </div>
            </li>

            <li className="dropdown">
                <a className="dropbtn">Co-curriculam   &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content"> 

                    <a>Cultural &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/culture/cul-member.pdf">Cultural Member</a>
                            </li> 
                            <li>
                                <a onClick={toggle} href="../documents/culture/rules.pdf">Rules & Regulations</a>
                            </li> 
                            <li>
                                <a onClick={toggle} href="../documents/culture/report.pdf">Cultural Report</a>
                            </li> 
                        
                            <li>
                                <a onClick={toggle} href="../documents/culture/stud-parti-report.pdf"  >Student Participation Report</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/culture/achivments.pdf"> Achivements </a>
                            </li> 
                            <li>
                                {/* <a onClick={toggle} href="../documents/culture/mega-event-report.pdf">Mega Events Report</a> */}
                            </li> 
                        </ul></a>

 

                        <a>Sport &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <a onClick={toggle} href="../documents/sport/profile1.pdf"  >Sport deparment profile</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/sport/Activities.pdf">Available Facilities</a>
                                
                            </li> 
                            <li>
                                <a onClick={toggle} href="https://mu.ac.in/wp-content/uploads/2021/02/Draft-University-Ghatna-_After-webinar-correction.pdf"  >Rules and Regulation </a>
                            </li> 
                            <li>
                                <a onClick={toggle} href="../documents/sport/events.pdf">Sport Events</a>
                            </li>
                        </ul></a>

                    <NavLink onClick={toggle} to="/nss">NSS</NavLink>

                    <a>DLLE &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <a onClick={toggle} href="../documents/dlle/project.pdf"  >Departments Rules & Regulations</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/dlle/dllemum.pdf">Faculty mumbers and students</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/dlle/enrollment-strength.pdf"  >Students inrollment strenth</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/dlle/DLLE-event-report.pdf"  >Activities Reports</a>
                            </li>
                        </ul>
                    </a>

                    <a>WDC &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <a onClick={toggle} href="../documents/WDC/WDC vison mission.pdf">WDC Vision,Mission </a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/WDC/WDC Committee Report.pdf">WDC Commitiee </a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/WDC/WDC EVENT REPORT.pdf">WDC Event Report</a>
                            </li> 
                            <li>
                                <a onClick={toggle} href="https://docs.google.com/forms/d/e/1FAIpQLScKLWcSB2KkH2Wi_2SdA6xieobzuTeyS40cCCso5Lv6ax03yg/viewform">INTERNAL COMPLIANCE (WDC) Application Form</a>
                            </li> 
                        </ul></a>
                    <a onClick={toggle} href="../documents/naac/support document/studentcell.pdf">Student Council</a>
                   
                    <NavLink onClick={toggle} to="/placement">Placement help - Committee</NavLink>
                    
                    <NavLink onClick={toggle} to="/CollegeAlumi"> College Alumni  </NavLink>
                </div> 
            </li>
            <li className="dropdown">
                <a className="dropbtn">Staff &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">
                    <NavLink onClick={toggle} to="/teaching-staff">Teaching Staff</NavLink>
                    <NavLink onClick={toggle} to="/non-teach-staff">Non-Teaching Staff</NavLink>
                    <NavLink onClick={toggle} to="/welfareschemes">Welfare Schemes</NavLink>
  <li>
                                <a onClick={toggle} href="../documents/naac/support%20document/6.2.2 Organogram.pdf"  >Organogram</a>
                            </li>
                </div>
            </li>

                {/* <li className="dropdown"><NavLink className="dropbtn" onClick={toggle} to="/library">Library</NavLink></li> */}
                <li className="dropdown">
                <a className="dropbtn">Library &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">
                    <NavLink onClick={toggle} to="/library">Library Profile</NavLink>
                    <NavLink onClick={toggle} to="/libraryEvent">Library Events</NavLink>
                    <a>Research work &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                        {/* <li>
                                <a onClick={toggle} href="#"  >Research policy</a>
                            </li> */}
                            <li>
                                <a onClick={toggle} href="../documents/Reasearch Paper/Research Project.pdf"  >Research Project</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="/researchpaper">Research Paper Publication</a>
                            </li> 
                            <li>
                                <a onClick={toggle} href="../documents/Reasearch Paper/Research Books.pdf">Research Book Publication</a>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/Reasearch Paper/Workshop and seminar report.pdf"  >Workshop and Seminar</a>
                            </li> 
                            
                        </ul></a>
                </div>
            </li>
 

            <li className="dropdown">
                <a className="dropbtn">Student Corner &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">

                    <a>Admission &nbsp;
                        <i className="fa fa-caret-down"></i>
                        <ul className="subdrop">
                            <li>
                                <NavLink onClick={toggle} to="/addmissionSchedule">Addmission Schedule</NavLink>
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/stud corner/Admission.pdf"  >Addmission Committee & Notice</a> 
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/stud corner/eligibility criteria.pdf"  >Eligibility Criteria</a> 
                            </li>
                            <li>
                                <a onClick={toggle} href="../documents/stud corner/prospectus.pdf"  > College Prospectus </a> 
                            </li>
                            <li>
                                <a onClick={toggle} href="../1000009883.pdf"  > College Fess Structure 2026-27 </a> 
                            </li>
                        </ul>
                    </a>
                    <li>
                        <NavLink onClick={toggle} to="/anti-ragging"> Anti-Raggging</NavLink>
                    </li>
                    <li>
                    <a onClick={toggle} href="../documents/stud corner/special.pdf"  >Special cell and scholarship</a>
                        {/* <NavLink onClick={toggle} to="/notfound"> Scholarship</NavLink> */}
                    </li>
                    <li>
                    <a onClick={toggle} href="../documents/clg committiee/collegemagzine.pdf"  >College magzine</a>
                        {/* <NavLink onClick={toggle} to="/notfound"> Scholarship</NavLink> */}
                    </li>
                    <li>
                        <NavLink onClick={toggle} to="/Notice"> College General Notice</NavLink>
                    </li> 
                    <li>
                        <NavLink onClick={toggle} to="/enotice"> Examination </NavLink>
                    </li> 
                    <NavLink onClick={toggle} to="/DlleFacultyMember"> CGRC  </NavLink>
                    <li>
                        <NavLink onClick={toggle} to="/feedback"> Feedback</NavLink>
                    </li> 
                    <li>
                    <a onClick={toggle} href="../documents/naac/support%20document/coc.pdf"  >Code of Conduct</a> 
                        {/* <NavLink onClick={toggle} to="/notfound"> Scholarship</NavLink> */}
                    </li>
                    <li>
                        <NavLink onClick={toggle} to="/career-katta"> Career Katta</NavLink>
                    </li> 

                </div>
            </li> 

            <li className="dropdown">
                <a className="dropbtn">NAAC &nbsp;
                    <i className="fa fa-caret-down"></i>
                </a>
                <div className="dropdown-content">
                    <NavLink onClick={toggle} to="/naac">IQAC</NavLink>
                         <li>
                                <a onClick={toggle} href="../documents/naac/support%20document/ssr.pdf"  >SSR</a> 
                            </li>
                    {/* <NavLink onClick={toggle} href="../documents/naac/iiqa.pdf">IIQA</NavLink> */}
                    <li>
                                <a onClick={toggle} href="../documents/naac/iiqa.pdf"  >IIQA</a> 
                            </li>
     <li>
                                <a onClick={toggle} href="../documents/naac/dvv.pdf"  >DVV Clarification</a> 
                            </li>
                </div>
            </li>

            <ul className="dropdown-menu" role="menu" aria-labelledby="dLabel">
            </ul>
        </ul>
    )
}

export default Navlinks;
